import { RETAIL_BASE_ROUTE } from 'config/retail/routes';

export const RETAIL_COMMERCIAL_CUSTOMER_INFORMATION_ROUTE = `${RETAIL_BASE_ROUTE}/business/customer-information`;
export const RETAIL_COMMERCIAL_UTILITY_ACCOUNT_INFORMATION_ROUTE = `${RETAIL_BASE_ROUTE}/business/utility-account-information`;
export const RETAIL_COMMERCIAL_BILLING_ADDRESS_ROUTE = `${RETAIL_BASE_ROUTE}/business/billing-address`;
export const RETAIL_COMMERCIAL_FLOW_CONFIRMATION_ROUTE = `${RETAIL_BASE_ROUTE}/business/confirmation`;
export const RETAIL_COMMERCIAL_SUCCESS_ROUTE = `${RETAIL_BASE_ROUTE}/business/success`;
